<template>
  <div class="a7-painel-resumo">
    <div class="a7-paiel-resumo-item" v-if="ultimaAtualizacao">
      <span class="header">Ult. Atualização</span>
      <span class="value">{{ultimaAtualizacao | dateFormat}}</span>
    </div>
    <div class="a7-paiel-resumo-item" v-if="erros || erros === 0">
      <span class="header">Erros</span>
      <span class="value">{{erros | integerFormat}}</span>
    </div>
    <span class="header" v-if="!erros && !ultimaAtualizacao">
      Não há dados
    </span>
  </div>
</template>
<script>
import MedicaoIndicadorRestResource from './MedicaoIndicadorRestResource'
import {
  FilterUtilities
}from 'guaxinim-web'
export default {
  name: "a7-painel-resumo",
  data: () => ({
    resumo: null
  }),
  props: {
    entity: {
      type: Object,
      default: {}
    },
    filterParams: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ultimaAtualizacao() {
      if (!this.resumo) return null
      return this.resumo.ultimaAtualizacao
    },
    erros() {
      if (!this.entity) return null
      return this.entity.avaliacaoErro
    }
  },
  watch: {
    entity(newValue){
      this.buscarDadosResumo(newValue)
    }
  },
  methods: {
    buscarDadosResumo(entity) {

      this.resumo = null;
      if (!entity) return;

      const dtoPainel = JSON.parse(JSON.stringify(entity))
      dtoPainel.filhos = null
      MedicaoIndicadorRestResource.findResumo(FilterUtilities.createFilterParamsString(this.filterParams),
      JSON.stringify(dtoPainel)).
        then(resumo => this.resumo = resumo).
        catch(err => this.$gw.defaultExceptionHandler.handleUnknownException(err, this));
    }
  }
}
</script>
<style lang="scss" scoped>
@import './A7PainelFormatacao';

.a7-painel-resumo {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}
.a7-paiel-resumo-item {
  display: flex;
  flex-direction: column;
  padding: 0px 10px;
  width: 100%;
  align-items: center;
  .header{
    font-weight: 600;
  }
  &:not(:first-child){
    border-left: 1px solid $grey-lighter;
  }
}

</style>
